interface RelativeToParResult {
  text: string
  color: string | null
}

export const isStablefordResultType = (resultType?: string | null): boolean => {
  return resultType === 'STABLEFORD_HCP' || resultType === 'STABLEFORD_SCRATCH'
}

export const isSystem36ResultType = (resultType?: string | null): boolean => {
  return resultType === 'SYSTEM36'
}

// A series counts as "System 36 only" when its primary result type is SYSTEM36 and it has no
// secondary result type other than SYSTEM36 — used to decide whether WHS handicap settings/UI
// (menMaxHandicap, womenMaxHandicap, handicapFactor, recommendations) are irrelevant for it.
export const seriesIsSystem36Only = (series: {resultType?: string | null, secondaryResultType?: string | null}): boolean => {
  return isSystem36ResultType(series.resultType) && (!series.secondaryResultType || isSystem36ResultType(series.secondaryResultType))
}

export const formatRelativeToPar = (value: number | null | undefined): RelativeToParResult => {
  if (value === null || value === undefined) {
    return { text: '-', color: null }
  }
  if (value === 0) {
    return { text: 'E', color: null }
  }
  if (value > 0) {
    return { text: `+${value}`, color: null }
  }
  // Under par (negative) - red color
  return { text: value.toString(), color: 'red' }
}
